import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import * as Form from "@radix-ui/react-form";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import messages from "./messages";
import Logo from "../Logo";
import {
  Button,
  Container,
  Content,
  NavigationButtons,
  SectionWrapper,
  SpinnerIcon,
} from "../Styles";
import EmailInput from "./EmailInput";
import CustomLabel from "../CustomLabel";
import Header from "../reuse/Header";

function ForgotPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: "onChange",
  });

  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const intl = useIntl();
  const emailMessage = "Email / Correo electrónico"; // intl.formatMessage(messages.email);
  const forgotPassword = "RESET PASSWORD / RESTABLECER LA CONTRASEÑA"; // intl.formatMessage(messages.forgot_password);

  const onSubmit = async (values) => {
    setLoading(true);
    setIsSubmitted(true);

    try {
      const { email } = values;
      await axios.post("/auth/forgetPassword", { email });

      toast.success(intl.formatMessage(messages.forgot_password_message));
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || intl.formatMessage(messages.error);

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Content>
        <SectionWrapper width="540px">
          <Logo />
          <Header
            text={forgotPassword}
            subtext1="A link will be sent to the address below to reset your password."
            subtext2="Se enviará un enlace a la dirección siguiente para restablecer su contraseña."
          />

          <Form.Root onSubmit={handleSubmit(onSubmit)}>
            <EmailInput
              label={<CustomLabel label={emailMessage} required />}
              name="email"
              register={register}
              errors={isSubmitted && errors}
            />

            <Button type="submit" disabled={!isValid || !isDirty || loading}>
              {loading ? (
                <>
                  <SpinnerIcon /> Loading
                </>
              ) : (
                "reset password / restablecer la contraseña"
              )}
            </Button>

            <NavigationButtons>
              <Link to="/">
                {/* <FormattedMessage {...messages.login} /> */}
                Login / Acceso
              </Link>
            </NavigationButtons>
          </Form.Root>
        </SectionWrapper>
      </Content>
    </Container>
  );
}

export default ForgotPassword;
